import Link from 'atomic/link';
import React, { useContext, useState } from 'react';
import Container from 'atomic/container';
import WidgetCategoryBlockProps from './widget-category-block.props';

import a0 from 'assets/images/icons/categories/a0.svg';
import a1 from 'assets/images/icons/categories/a1.svg';
import a2 from 'assets/images/icons/categories/a2.svg';
import a3 from 'assets/images/icons/categories/a3.svg';
import a5 from 'assets/images/icons/categories/a5.svg';
import a6 from 'assets/images/icons/categories/a6.svg';
import a8 from 'assets/images/icons/categories/a8.svg';
import a10 from 'assets/images/icons/categories/a10.svg';
import a11 from 'assets/images/icons/categories/a11.svg';
import a12 from 'assets/images/icons/categories/a12.svg';
import a13 from 'assets/images/icons/categories/a13.svg';
import a14 from 'assets/images/icons/categories/a14.svg';
import a15 from 'assets/images/icons/categories/a15.svg';
import a16 from 'assets/images/icons/categories/a16.svg';
import a18 from 'assets/images/icons/categories/a18.svg';
import a19 from 'assets/images/icons/categories/a19.svg';
import a21 from 'assets/images/icons/categories/a21.svg';
import a22 from 'assets/images/icons/categories/a22.svg';
import a23 from 'assets/images/icons/categories/a23.svg';
import a24 from 'assets/images/icons/categories/a24.svg';
import a25 from 'assets/images/icons/categories/a25.svg';
import a26 from 'assets/images/icons/categories/a26.svg';
import a28 from 'assets/images/icons/categories/a28.svg';
import a29 from 'assets/images/icons/categories/a29.svg';
import a30 from 'assets/images/icons/categories/a30.svg';

import { TeApiContext } from '@ecommerce/nest-ssr/common';
import Icon from 'atomic/icon';

import './widget-category-block.scss';

const IMAGES: { [key: string]: string; } = {
    a0,
    a1,
    a2,
    a3,
    a5,
    a6,
    a8,
    a10,
    a11,
    a12,
    a13,
    a14,
    a15,
    a16,
    a18,
    a19,
    a21,
    a22,
    a23,
    a24,
    a25,
    a26,
    a28,
    a29,
    a30
};

const WidgetCategoryBlock: React.FC<WidgetCategoryBlockProps> = ({ data }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const SHOW_LIMIT = api.getDevice() === 'desktop' ? 16 : 30;
    const [showMore, setShowMore] = useState(false);
    const numberOfItems = showMore ? data.length : SHOW_LIMIT;

    if (data.length === 0) {
        return null;
    }

    return (
        <Container className="w-category-block">
            <div className="w-category-block__list">
                {data.slice(0, numberOfItems).map(department => (
                    <Link
                        className="item"
                        href={department.url}
                        key={department.name}
                        title={department.name}
                    >
                        <div className="item__circle">
                            <img
                                src={IMAGES[String(department.id)]}
                                alt={`Departament ${department.name}`}
                            />
                        </div>
                        <div className="item__title">
                            {department.name}
                        </div>
                    </Link>
                ))}
            </div>

            {data.length > SHOW_LIMIT && !showMore && (
                <div
                    className="w-category-block__show-more"
                    onClick={(): void => setShowMore(true)}
                >
                    Wszystkie kategorie
                    <Icon name="arrow-right" color="primary" size={24} />
                </div>
            )}
        </Container>
    );
};

export default WidgetCategoryBlock;
